import cookieInfo from '@alife/bc-cookie-info';
import { isIframe, postLogin } from './iframe-post';
interface CallType {
  callback: () => void;
}

let xmanObj: any;

export default (
  callback?: CallType['callback'],
  afterCall?: () => void,
) => {
  // 登陆直接执行
  if (cookieInfo.getIsLoggedIn() && callback) {
    return callback();
  }

  // iframe登录消息
  if (isIframe && callback) {
    postLogin();
    return;
  }

  const { SCXman, loadXman } = window as any;
  // 新版本
  if (loadXman) {
    xmanObj = loadXman({
      allSuccess: () => {
        callback && callback();
      },
      dialogCallback: (state: boolean) => {
        !state && afterCall && afterCall();
      },
    });
    if (callback) {
      xmanObj.show();
    }
    return;
  }

  // 老版本
  if (SCXman) {
    xmanObj = new SCXman.Popup({
      members: 'both',
    });
    xmanObj.on('LOGIN_SUCCESS', () => {
      callback && callback();
    });
    xmanObj.on('AFTER_HIDE', () => {
      xmanObj.set('members', 'both');
      xmanObj.set('activeIndex', 0);
      callback && callback();
    });
    if (callback) {
      xmanObj.show();
    }
    return;
  }
};
